const genericError = { message: "Something Went Wrong", status: 500 };

function defaultCatch(error: any, resolve: any) {
  resolve(error?.response || genericError);
}

export default defaultCatch;
